/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// Import Axios
import axios from 'axios';
import {csrfTokenManager} from "./CsrfTokenManager";

// Set default headers
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Remove all existing token-related axios defaults
delete axios.defaults.xsrfCookieName;
delete axios.defaults.xsrfHeaderName;


/**
 * Request interceptor
 */
axios.interceptors.request.use(async config => {
    const method = config.method?.toLowerCase();

    // Don't add CSRF token for GET requests or CSRF token endpoint
    if (method === 'get' || config.url === '/csrf-token') {
        return config;
    }

    // Ensure we have a token
    if (!csrfTokenManager._token) {
        await csrfTokenManager.refreshToken();
    }

    // Set headers and form data
    config.headers['X-CSRF-TOKEN'] = csrfTokenManager._token;

    if (config.data instanceof FormData && !config.data.has('_token')) {
        config.data.set('_token', csrfTokenManager._token);
    } else if (config.data && !config.data._token) {
        config.data._token = csrfTokenManager._token;
    }

    return config;
});


// Response interceptor
axios.interceptors.response.use(
    async response => {
        // Update token if provided in response header
        const newToken = response.headers?.['x-csrf-token'];
        if (newToken) {
            try {
                await csrfTokenManager.updateFromResponse(newToken);
            } catch (error) {
                console.error('Failed to update CSRF token:', error);
                // Optionally, you might want to trigger some error handling here
            }
        }
        return response;
    },
    async error => {
        const { config, response } = error;

        if (response?.status === 419 && config && !config._retry) {
            config._retry = true;

            try {
                // Force token refresh
                await csrfTokenManager.refreshToken();
                // Retry the original request
                return axios(config);
            } catch (refreshError) {
                console.error('Failed to refresh CSRF token:', refreshError);
                // You might want to handle this differently, e.g., redirect to login
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);
